import { render } from "./HomeApproach.vue?vue&type=template&id=c3109bfa&scoped=true"
import script from "./HomeApproach.vue?vue&type=script&lang=js"
export * from "./HomeApproach.vue?vue&type=script&lang=js"

import "./HomeApproach.vue?vue&type=style&index=0&id=c3109bfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3109bfa"]])

export default __exports__